module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "tabs hide-small"
  }, [_c('div', {
    class: [_vm.tab === 'main' ? 'active' : ''],
    on: {
      "click": function($event) {
        _vm.tab = 'main'
      }
    }
  }, [_vm._v("Main details")])]), _vm._v(" "), _c('div', {
    staticClass: "tabs tabs-right hide-small"
  }, [_c('div', {
    class: [_vm.isValid ? 'valid' : 'disabled', 'save-tab'],
    on: {
      "click": function($event) {
        return _vm.save(false)
      }
    }
  }, [_vm._v(_vm._s(_vm.saveOrUpdate))]), _vm._v(" "), _c('div', {
    class: [_vm.isValid ? 'valid' : 'disabled', 'save-tab'],
    on: {
      "click": function($event) {
        return _vm.save(true)
      }
    }
  }, [_vm._v(_vm._s(_vm.saveOrUpdate) + " & exit")])]), _vm._v(" "), _c('div', {
    staticClass: "dropdown show-small dropdown-admin-tabs"
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', {
    on: {
      "click": function($event) {
        _vm.tab = 'main'
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\n          Main details\n          "), (_vm.tab === 'main') ? _c('i', {
    staticClass: "fa fa-check-square-o"
  }) : _vm._e()])]), _vm._v(" "), _c('li', {
    class: [_vm.isValid ? 'valid' : 'disabled', 'save-dropdown'],
    on: {
      "click": function($event) {
        return _vm.save(false)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.saveOrUpdate))])]), _vm._v(" "), _c('li', {
    class: [_vm.isValid ? 'valid' : 'disabled', 'save-dropdown'],
    on: {
      "click": function($event) {
        return _vm.save(true)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.saveOrUpdate) + " & exit")])])])]), _vm._v(" "), _c('section', {
    staticClass: "clearfix",
    attrs: {
      "id": "main-content"
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "admin-content",
      "id": "location-content"
    },
    slot: "admin-content"
  }, [(_vm.tab === 'main') ? _c('div', [_c('div', {
    staticClass: "col-xs-12 col-sm-6 main-location-details left top-small"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "ext-name"
    }
  }, [_vm._v("Name *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.name),
      expression: "entity.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "role-name"
    },
    domProps: {
      "value": (_vm.entity.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "pa-ext"
    }
  }, [_vm._v("External ID")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.externalId),
      expression: "entity.externalId"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "pa-ext"
    },
    domProps: {
      "value": (_vm.entity.externalId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "externalId", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 main-location-details left bottom-small"
  }, [(_vm.entity.id) ? _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Add Ports to Port Area")]), _vm._v(" "), _c('autocomplete', {
    attrs: {
      "dataset": _vm.ports,
      "title": "Port Search",
      "placeHolder": "Type to search",
      "initVal": _vm.portAreaLocation,
      "fnFormatText": _vm.displayLocation,
      "fnSelectValue": _vm.displayLocation
    },
    on: {
      "changing": function (data) { return _vm.locationSearchText = data; },
      "selection-made": _vm.selectPort
    }
  })], 1), _vm._v(" "), _c('vue-table', {
    attrs: {
      "showDelete": true,
      "tableData": _vm.portAreaToPorts,
      "tableTitle": "Ports",
      "fields": [{
        header: 'Port',
        prop: function (obj) { return obj.port ? _vm.displayLocation(obj.port) : ''; }
      }]
    },
    on: {
      "table-delete-request": _vm.removeLocation
    }
  })], 1) : _c('div', {
    staticClass: "mt-20 mb-15"
  }, [_c('p', [_vm._v("Once you have saved the Port Area, you will be able to add Ports")])])])]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn dropdown-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown"
    }
  }, [_vm._v("\n      Options\n      "), _c('span', {
    staticClass: "caret"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9d45168a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/admin/components/PortArea/PortArea.vue
// module id = 2261
// module chunks = 1